import AuthMixin from '@/components/mixins/auth-mixin'
import EventBus from '@/components/mixins/event-bus-mixin';
import { signInWithRedirect as AmplifySignInWithRedirect } from 'aws-amplify/auth';
import { useCognitoAuthStore } from '@base-shared/stores/cognito-auth';
import { handleRequest } from '@base-shared/utils/request-handler';

export default {
  name: 'sso',
  inject: [
    '$utils',
    '$api',
    '$apiError'
  ],
  components: {},
  props: {},
  watch: {
    '$route.params' () {
      this.setDefaultData()
    }
  },
  mixins: [AuthMixin],
  data () {
    return {
      providerName: null,
      error: null
    }
  },
  methods: {
    async setDefaultData () {
      this.providerName = this.$route.params.providerName
      await this.getSSODetails()
    },
    async getSSODetails () {
      this.$utils.mainLoader(true)
      try {
        const cognitoAuthStore = useCognitoAuthStore();

        await cognitoAuthStore.cleanupLocalSession();
        const hub = cognitoAuthStore.hubAuth;
        if (hub && hub.isHubEnabled()) {
          // If Hub is enabled, we can reset the auth session in Hub too
          hub.updateAuthSession(null);
        }

        const { error, response } = await handleRequest(async () => {
          const result = await cognitoAuthStore.configureWithProvider(this.providerName);
          return result.response;
        });

        if (error) {
          throw error;
        }

        await AmplifySignInWithRedirect({
          provider: {
            custom: response
          }
        })
      } catch (error) {
        this.$utils.mainLoader(false)
        const errorMessage = error?.message?.includes('Provider Not Found')
          ? this.$t('errors.invalid.provider')
          : this.$t('errors.loginUnexpectedError');

        EventBus.$emit('SHOW_CUSTOM_NOTIFICATION', {
          type: 'error',
          alert: {
            message: errorMessage
          },
          callbacks: { eventOnClose: () => { this.$router.push('/', () => {}); } }
        });
      }
    }
  },
  async mounted () {
    await this.setDefaultData()
  }
}
